import React from "react"
import { Table } from "react-bootstrap"
import Json from "react-json-view"
import { size, values } from "lodash"

import Button from "../Button"
import DetailsModal from "./TrackingTable.Modal"

async function getX(x) {
  const response = await fetch(x, {
    method: 'GET', 
    headers: { 
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "same-origin",
  })
  const json = await response.json()
  return json
}

class TrackingTable extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { 
      tracks: [],
      sessions: {},
      showSessionDetails: null
    }
  }
  
  componentDidMount() {
    Promise.all([getX("/tracking"), getX("/sessions")])
      .then(([tracks, sessions]) => this.setState({ tracks, sessions }))
  }
  
  render() {
    if (size(this.state.sessions) == 0) console.log(<h1>No tracks</h1>)

    const sessionsList = values(this.state.sessions)

    return (
      <React.Fragment>
        <Table>
          <thead>
            <tr>
              { ["id cliente", "id sesión", "#tracks", "from", "to", "more"].map(col => <th key={col}>{col}</th>) }
            </tr>
          </thead>
          <tbody>
            {
              sessionsList.map(session => (
                <tr key={session.id}>
                  <td>{session.clientId}</td>
                  <td>{session.id}</td>
                  <td>{session.tracks.length}</td>
                  <td>{session.firstTimestamp}</td>
                  <td>{session.lastTimestamp}</td>
                  <td>
                    <Button onClick={() => this.setState({ showSessionDetails: session.id })}>
                      Ver más
                    </Button>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </Table>

        {
          this.state.showSessionDetails && (
            <DetailsModal 
              session={this.state.sessions[this.state.showSessionDetails]}
              onClose={() => this.setState({ showSessionDetails: null })}
            />
          )
        }
      </React.Fragment>
    )
  }
}

export default TrackingTable




// WEBPACK FOOTER //
// ./src/app/admin/components/tables/TrackingTable.jsx